(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventDashboardDialogController', EventDashboardDialogController);

    EventDashboardDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'EventDashboard'];

    function EventDashboardDialogController($scope, $uibModalInstance, entity, EventDashboard) {
        var vm = this;

        vm.dashboard = entity;
        vm.clear = clear;
        vm.save = save;
        vm.exampleJson = buildExampleJson();

        vm.dashboard.active = vm.dashboard.active !== false;
        vm.dashboard.showInNavbar = !!vm.dashboard.showInNavbar;
        vm.dashboard.displayOrder = vm.dashboard.displayOrder || 0;
        vm.dashboard.configJson = vm.dashboard.configJson || angular.toJson(vm.exampleJson, true);

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.dashboard.id !== null) {
                EventDashboard.update(vm.dashboard, onSaveSuccess, onSaveError);
            } else {
                EventDashboard.save(vm.dashboard, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('wamasysApp:eventDashboardUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function buildExampleJson() {
            return {
                table: {
                    enabled: true,
                    columns: [
                        {fieldCode: 'dateRecord', label: 'Date'},
                        {fieldCode: 'agency', label: 'Agence'},
                        {fieldCode: 'area', label: 'Zone'},
                        {fieldCode: 'category', label: 'Catégorie'},
                        {fieldCode: 'subCategory', label: 'Sous-catégorie'},
                        {fieldCode: 'title', label: 'Titre'},
                        {fieldCode: 'participantCount', label: 'Participants'}
                    ],
                    summaries: [
                        {fieldCode: 'participantCount', label: 'Somme participants', aggregation: 'sum'},
                        {fieldCode: 'participantCount', label: 'Moyenne participants', aggregation: 'avg'},
                        {fieldCode: 'participantCount', label: 'Médiane participants', aggregation: 'median'}
                    ]
                },
                map: {
                    enabled: true
                },
                metrics: [
                    {fieldCode: null, label: 'Nombre d’événements', aggregation: 'count'},
                    {fieldCode: 'participantCount', label: 'Participants', aggregation: 'sum'}
                ],
                timeHistograms: [
                    {
                        label: 'Évolution mensuelle',
                        interval: 'month',
                        dateFieldCode: 'dateRecord',
                        series: [
                            {fieldCode: null, label: 'Nombre d’événements', aggregation: 'count', displayType: 'bar'},
                            {fieldCode: 'participantCount', label: 'Participants', aggregation: 'sum', displayType: 'line'}
                        ]
                    }
                ],
                histograms: [
                    {groupByFieldCode: 'activity_type', label: 'Type d’activité', aggregation: 'count'},
                    {groupByFieldCode: 'zone', valueFieldCode: 'participantCount', label: 'Participants par zone', aggregation: 'sum'}
                ],
                pies: [
                    {groupByFieldCode: 'status', label: 'Statut', aggregation: 'count'},
                    {groupByFieldCode: 'responsible', valueFieldCode: 'clientUuid', label: 'Responsables uniques', aggregation: 'unique_count'}
                ]
            };
        }
    }
})();
